import { getEnv } from '@/utility/env';

export const filesUrl = 'https://files.neodtx.com';

export function getConfigUrl() {
    const env = getEnv('APP_ENV');
    if (['production', 'development'].includes(env))
        return `${filesUrl}/setup/configs-${env}.json?` + Math.random();
    return `${filesUrl}/setup/configs.json?` + Math.random();
}
